import clubListStore from '@modules/club/club-list-store';
import clubViewStore from '@modules/club/club-view-store';
import clubImporterStore from '@modules/club/club-importer-store';
import clubFormStore from '@modules/club/club-form-store';
import clubDestroyStore from '@modules/club/club-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: clubDestroyStore,
    form: clubFormStore,
    list: clubListStore,
    view: clubViewStore,
    importer: clubImporterStore,
  },
};
